var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttachment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Essentials__x2F__Interface",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#8D8D8D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.6,22.3c-1,0-2-0.4-2.7-1.1c-0.8-0.8-1.3-1.9-1.2-3c0.1-1.2,0.6-2.3,1.7-3.3L13.8,3.4 c1.1-1.1,2.5-1.6,4-1.6c1.5,0,2.9,0.6,4,1.6c2.2,2.2,2.2,5.7,0,7.9l-10,10c-0.3,0.3-0.7,0.3-1,0c-0.3-0.3-0.3-0.7,0-1l10-10 c1.6-1.6,1.6-4.3,0-5.9c-0.8-0.8-1.8-1.2-3-1.2c-1.1,0-2.2,0.4-3,1.2L3.3,15.8c-0.8,0.8-1.2,1.6-1.2,2.4c0,0.7,0.2,1.4,0.8,2 c1.1,1.1,3,0.9,4.3-0.5l9.4-9.4C16.9,10,17,9.7,17,9.4c0-0.3-0.1-0.7-0.4-0.9c-0.5-0.5-1.3-0.5-1.8,0l-8,8c-0.3,0.3-0.7,0.3-1,0 c-0.3-0.3-0.3-0.7,0-1l8-8c1.1-1.1,2.8-1.1,3.8,0c0.5,0.5,0.8,1.2,0.8,1.9c0,0.7-0.3,1.4-0.8,1.9l-9.4,9.4 C7.2,21.7,5.9,22.3,4.6,22.3z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.caa6e3e9ab3992b4da49eecc18a35cf3.svg";
export { ForwardRef as ReactComponent };